module.exports = __webpack_public_path__ + "img/GB-WhatsApp-temporary-ban-timer.1ef89255.webp";